import axios from "axios"
import { MenuImportType } from "../events/MenuImport/types"
import type { HttpHeaders } from "./types"
import { request } from "../utils/http"
import { defer, Observable } from "rxjs"

export type PrepareMenuImportUploadRequest = {
    filename: string
    fileType: string
    type: MenuImportType
}

export type PrepareMenuImportUploadResponse = {
    importId: string
    fileKey: string
    signedRequest: string
}

export const prepareMenuImportUploadApi = (
    headers: HttpHeaders,
    body: PrepareMenuImportUploadRequest
): Observable<PrepareMenuImportUploadResponse> =>
    defer(() =>
        request({
            method: "POST",
            path: "/menu/prepare-upload",
            body: body,
            headers: headers,
        })
    )

export const uploadMenuImportFile = (signedRequest: string, file: File, fileType: string) =>
    defer(() => axios.put(signedRequest, file, { headers: { "Content-Type": fileType } }))
